import Handsontable from 'handsontable';
import { getFirstSelection } from '../../selectionUtils/tableSelectionAccessors';
import { isSelectingSingleSelection } from '../../selectionUtils/tableSelectionPredicateUtils';

/**
 * Adds a formula to the currently selected cell in the Handsontable instance.
 */
export const addHotTableFormulaToCell = (hotInstance: Handsontable, cellSelections = hotInstance.getSelected()) => {
    if (!cellSelections) return;

    if (!isSelectingSingleSelection(cellSelections)) return;

    const cellSelection = getFirstSelection(cellSelections);
    if (!cellSelection) return;

    requestAnimationFrame(() => {
        if (hotInstance.isDestroyed) return;

        hotInstance.getActiveEditor()?.beginEditing('=');
    });
};
